import { render, staticRenderFns } from "./TasksListTable.vue?vue&type=template&id=5b619b6e&scoped=true&"
import script from "./TasksListTable.vue?vue&type=script&lang=js&"
export * from "./TasksListTable.vue?vue&type=script&lang=js&"
import style0 from "./TasksListTable.vue?vue&type=style&index=0&id=5b619b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b619b6e",
  null
  
)

export default component.exports